import { Text3D, MeshDistortMaterial, Center } from "@react-three/drei"
import { useRef } from "react"
import * as THREE from 'three'
import { animated, useSpring } from "@react-spring/three"
import { copyURLToClipboard } from "../logicHelpers/helpers"
import { trackEvent } from '../api'
import layout from "../dictionaries/layout"
import { useAtomValue } from "jotai"
import { languageAtom } from "../GlobalState"
import translations from "../dictionaries/translations"

export default function ShareLinkButton({ rotation, position, device='landscapeDesktop' }) {

  const language = useAtomValue(languageAtom)
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"

  const shareLinkTextMaterialRef = useRef()
  const shareLinkBoxMaterialRef = useRef()
  function handleShareLinkPointerEnter(e) {
    e.stopPropagation()
    shareLinkTextMaterialRef.current.color = new THREE.Color('green')
    shareLinkBoxMaterialRef.current.color = new THREE.Color('green')
    document.body.style.cursor = "pointer";
  }
  function handleShareLinkPointerLeave(e) {
    e.stopPropagation()
    shareLinkTextMaterialRef.current.color = new THREE.Color('yellow')
    shareLinkBoxMaterialRef.current.color = new THREE.Color('yellow')
    document.body.style.cursor = "default";
  }
  const AnimatedMeshDistortMaterial = animated(MeshDistortMaterial)
  const [springs, apiCopyLink] = useSpring(() => ({        
    from: {
      opacity: 0, 
    }
  }))
  async function handleShareLinkPointerUp(e) {
    e.stopPropagation()
    if (device === 'portrait') {
      if (navigator.share) {
        try {
          await navigator.share({
            title: 'Yut Nori',
            text: "Let's play a game!",
            url: window.location.href,
          })

          await trackEvent({ surface: 'end_scene', action: 'share_lobby', category: 'ui', metadata: { method: 'native' } })
        } catch (err) {
          console.error('Error sharing:', err)
        }
      } else {
        alert('Web Share API is not supported. Copy the URL to share.')
      }
    } else {
      copyURLToClipboard()
      apiCopyLink.start({
        from: {
          opacity: 1
        },
        to: [
          {
            opacity: 1
          },
          { 
            opacity: 0,
            delay: 500,
            config: {
              tension: 170,
              friction: 26
            }
          }
        ]
      })
      
      await trackEvent({ surface: 'end_scene', action: 'share_lobby', category: 'ui', metadata: { method: 'clipboard' } })
    }
  }

  return <group name='share-link-button' rotation={rotation} position={position}>
    <mesh>
      <boxGeometry args={layout[device].endSceneActionButtons.shareLinkButton.outerBox.args}/>
      <meshStandardMaterial ref={shareLinkBoxMaterialRef} color='yellow'/>
    </mesh>
    <mesh>
      <boxGeometry args={layout[device].endSceneActionButtons.shareLinkButton.innerBox.args}/>
      <meshStandardMaterial color='black'/>
    </mesh>
    <mesh
      name='share-link-button-wrapper'
      onPointerEnter={(e) => handleShareLinkPointerEnter(e)}
      onPointerLeave={(e) => handleShareLinkPointerLeave(e)}
      onPointerUp={(e) => handleShareLinkPointerUp(e)}
    >
      <boxGeometry args={layout[device].endSceneActionButtons.shareLinkButton.wrapper.args}/>
      <meshStandardMaterial color="grey" transparent opacity={0}/>
    </mesh>
    <Center position={[0, 0, layout[device].endSceneActionButtons.shareLinkButton.text.position[2]]}>
      <Text3D
        font={fontUrl}
        size={layout[device].endSceneActionButtons.shareLinkButton.text.fontSize}
        height={0.03} 
      >
        {translations.endScenes.shareLink[language]}
        <meshStandardMaterial ref={shareLinkTextMaterialRef} color='yellow'/>
      </Text3D>
    </Center>
    <Text3D 
      name='copied-tooltip'
      font="/fonts/Luckiest Guy_Regular.json"
      position={layout[device].endSceneActionButtons.shareLinkButton.copiedText.position}
      size={layout[device].endSceneActionButtons.shareLinkButton.copiedText.fontSize}
      height={0.01}
    >
      copied!
      <AnimatedMeshDistortMaterial
        speed={5}
        distort={0}
        color='limegreen'
        transparent
        opacity={springs.opacity}
      />
    </Text3D>
  </group>
}